import { Coordinates } from '@store/location/location.slice';

type DistancePoints = {
  pointA: Coordinates;
  pointB: Coordinates;
};

export function getCurrentLocation(): Promise<Coordinates> {
  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        resolve({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        });
      },
      (error) => {
        reject(error);
      }
    );
  });
}

export const sortByProximity = <T extends Partial<Coordinates>>(
  coordinates: Coordinates,
  coordinatesList: T[]
) => {
  const dealersCopy = [...coordinatesList];
  if (!coordinates?.latitude || !coordinates?.longitude) {
    return dealersCopy;
  }
  return [...coordinatesList].sort((a, b) => {
    const distanceA = calcDistance({
      pointA: coordinates,
      pointB: {
        latitude: a?.latitude || 0,
        longitude: a?.longitude || 0,
      },
    });
    const distanceB = calcDistance({
      pointA: coordinates,
      pointB: {
        latitude: b?.latitude || 0,
        longitude: b?.longitude || 0,
      },
    });
    return distanceA - distanceB;
  });
};

export const calcDistance = ({ pointA, pointB }: DistancePoints): number => {
  const toRad = (value: number): number => (value * Math.PI) / 180;

  const R = 6371;
  const dLat = toRad(pointB?.latitude - pointA?.latitude);
  const dLng = toRad(pointB?.longitude - pointA.longitude);

  const a =
    Math.pow(Math.sin(dLat / 2), 2) +
    Math.cos(toRad(pointA.latitude)) *
      Math.cos(toRad(pointB.latitude)) *
      Math.pow(Math.sin(dLng / 2), 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return R * c;
};
